import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { SERVER_URL } from "../config/config";
import { JailListType } from "../types/Jail/JailListType";

export interface JailState {
  jailList: JailListType[];
  isLoadnigJailList: boolean;
}

const initialState: JailState = {
  jailList: [],
  isLoadnigJailList: false,
};

export const getJailList = createAsyncThunk("jail/getJailList", async () => {
  const response = await axios.get(`${SERVER_URL}/profile/jail`);
  return response.data;
});

export const jailSlice = createSlice({
  name: "jail",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getJailList.pending, (state) => {
      state.isLoadnigJailList = true;
    });
    builder.addCase(getJailList.fulfilled, (state, { payload }) => {
      state.isLoadnigJailList = false;
      state.jailList = payload.map((data: any) => ({
        id: data.id,
        name: data.name,
        jailed: data.jailed,
        jailedUntil: data.jailedUntil,
        city: data.city,
        crimeType: data.crimeType,
        userFamily: data?.userFamily,
      }));
    });
    builder.addCase(getJailList.rejected, (state) => {
      state.isLoadnigJailList = false;
    });
  },
});

export default jailSlice.reducer;
